export type Nullable<T> = T | null | undefined

export const THANK_YOU_PAGE_URL = 'thanks'

export const getIdsFromQuery = (
  query: string[],
): {
  charityId: string
  campaignId: string
  pageId: Nullable<string>
  pageBucketId: Nullable<string>
  isThankYouPage: boolean
} => {
  return {
    charityId: query[0],
    campaignId: query[1],
    pageId: isGuid(query[2]) ? query[2] : null,
    pageBucketId: !isGuid(query[2]) && query[2] === 'pagebucket' ? query[3] : null,
    // for campaign landing page and page url.
    // '/thanks' is reserved in the backend so can't be set as page slug
    isThankYouPage:
      query[2] === THANK_YOU_PAGE_URL || query[3] === THANK_YOU_PAGE_URL || query[4] === THANK_YOU_PAGE_URL,
  }
}

export const isGuid = (value: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)

export function toSearchParams(options: Record<string, Nullable<string | string[] | number | boolean | undefined>>) {
  const params = new URLSearchParams()
  Object.entries(options).forEach(([key, value]) => {
    if (value) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          params.append(key, String(v))
        })
      } else {
        params.append(key, String(value))
      }
    }
  })
  return params.toString()
}
